import store from '../store';

store.watch((state) => state["activeCustomer"]["customer"], async (value) => {
    console.log("watch: ", value)

    // get active cart
    await store.dispatch("cart/syncBasket", value);

    // get active order
    await store.dispatch("checkout/syncDraftOrder", value);
});